<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
    <path id="info-circle-solid" d="M23,8A15,15,0,1,0,38,23,15,15,0,0,0,23,8Zm0,6.653a2.54,2.54,0,1,1-2.54,2.54A2.54,2.54,0,0,1,23,14.653Zm3.387,15.363a.726.726,0,0,1-.726.726H20.339a.726.726,0,0,1-.726-.726V28.565a.726.726,0,0,1,.726-.726h.726V23.968h-.726a.726.726,0,0,1-.726-.726V21.79a.726.726,0,0,1,.726-.726H24.21a.726.726,0,0,1,.726.726v6.048h.726a.726.726,0,0,1,.726.726Z" transform="translate(-8 -8)" fill="#dbdfe6"/>
  </svg>
</template>

<script>
  export default {
    name: 'IconInfo',
  }
</script>
